<template>
    <div id="myapp">
      <!-- Sidebar and Main Content -->
      <div class="appClass">
        <!-- Sidebar -->
        <div :class="['sidebar', { 'sidebar-open': isSidebarOpen }]">
            <div style="position: absolute; top: 0; right: 0; width: auto;">
                <button class="btn btn-secondary close-btn mobile-only" @click="toggleSidebar">
                    <i class="bi" :class="isSidebarOpen ? 'bi-x' : 'bi-list'"></i>
                </button>
                <button class="btn btn-warning lock-btn desktop-only" @click="toggleLock">
            <i class="bi" :class="isSidebarLocked ? 'bi-lock' : 'bi-unlock'"></i>
          </button>
            </div>

          <div style="text-align: center;">
            <h3 style="color: white; padding: 10px;">My Tution Wave</h3>
            <hr style="border: 1px solid white; width: 80%; margin: 0 auto;" />
          </div>


  
          <!-- <button class="btn btn-secondary close-btn" @click="toggleSidebar">
            <i class="bi" :class="isSidebarOpen ? 'bi-x' : 'bi-list'"></i>
          </button> -->
          <div class="sidebar-content">
            <ul>
              <!-- Icons only when sidebar is closed -->
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('home')"><i class="bi bi-house-door"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('institute-profile')"><i class="bi bi-building"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('students')"><i class="bi bi-people"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('teachers')"><i class="bi bi-person-badge"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('payments')"><i class="bi bi-cash-coin"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('scan-qr')"><i class="bi bi-qr-code-scan"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('settings')"><i class="bi bi-gear"></i></a></li>
              <li v-if="!isSidebarOpen"><a href="#" @click.prevent="showPage('about')"><i class="bi bi-info-circle"></i></a></li>
              <!-- Icons and text when sidebar is open -->
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('home')"><i class="bi bi-house-door"></i>Home</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('institute-profile')"><i class="bi bi-building"></i>Profile</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('students')"><i class="bi bi-people"></i>Students</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('teachers')"><i class="bi bi-person-badge"></i>Teachers</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('payments')"><i class="bi bi-cash-coin"></i>Payments</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('scan-qr')"><i class="bi bi-qr-code-scan"></i>Scan QR</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('settings')"><i class="bi bi-gear"></i>Settings</a></li>
              <li v-if="isSidebarOpen"><a href="#" @click.prevent="showPage('about')"><i class="bi bi-info-circle"></i>About</a></li>
            </ul>
          </div>
        </div>
  
        <!-- Main Content -->
        <main :class="['main-content', { 'shift-right': isSidebarOpen }]">
          <nav class="navbar navbar-expand-lg navbar-light bg-light">
            <div style="display: flex;">
            <a v-show="!isSidebarOpen" class="navbar-brand appName" href="#">My Tution Wave</a>
            <button class="btn btn-primary ms-auto" @click="toggleSidebar">
              <i class="bi" :class="isSidebarOpen ? 'bi-x' : 'bi-list'"></i> <!-- Toggle icon -->
            </button>
            
            </div>
            <a class="navbar-brand appNameA" href="#">My Tution Wave</a>
            <div class="collapse navbar-collapse" id="navbarNav">
              <ul class="navbar-nav">
                <li class="nav-item">
                  <a class="nav-link active" aria-current="page" href="#"><i class="bi bi-house-door"></i> Home</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#"><i class="bi bi-star"></i> Features</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#"><i class="bi bi-cash"></i> Pricing</a>
                </li>

              </ul>
              <div class="appNameB">
                <h3>My Tution Wave</h3>
            </div>


            </div>


            <div class="loginHeader desktop-only">
                <LoginHeader/>
            </div>

            <div v-show="!isSidebarOpen" class="loginHeader mobile-only">
                <LoginHeader/>
            </div>
          </nav>
  
          <div>
            <div class="main-content">
              <div class="sub-content" v-if="currentPage === 'home'">
                <HomeView/>
              </div>
              <div class="sub-content" v-if="currentPage === 'institute-profile'">
                <InstituteProfile/>
              </div>
              <div class="sub-content" v-if="currentPage === 'students'">
                <StudentProfile/>
              </div>
              <div class="sub-content" v-if="currentPage === 'teachers'">
                <TeacherProfile/>
              </div>
              <div class="sub-content" v-if="currentPage === 'payments'">
                <PaymentView/>
              </div>
              <div class="sub-content" v-if="currentPage === 'scan-qr'">
                <QRScanView/>
              </div>
              <div class="sub-content" v-if="currentPage === 'settings'">
                <SettingsView/>
              </div>
              <div class="sub-content" v-if="currentPage === 'about'">
                <AboutView/>
              </div>
            </div>
          </div>
  
          <!-- Add your main content here -->
        </main>
      </div>
    </div>
  </template>
  
  <script>
  import LoginHeader from '@/components/LoginHeader.vue';
  import HomeView from '@/components/HomeView.vue';
  import SettingsView from '@/components/SettingsView.vue';
  import AboutView from '@/components/AboutView.vue';
  import InstituteProfile from '@/components/InstituteDashboard/InstituteProfile.vue';
import TeacherProfile from '@/components/InstituteDashboard/TeacherProfile.vue';
import StudentProfile from '@/components/InstituteDashboard/StudentProfile.vue';
import PaymentView from '@/components/InstituteDashboard/PaymentView.vue';
import QRScanView from '@/components/InstituteDashboard/QRScanView.vue';
  
  export default {
    components: {
        LoginHeader,
        HomeView,
        InstituteProfile,
        StudentProfile,
        TeacherProfile,
        PaymentView,
        QRScanView,
        SettingsView,
        AboutView,
    },
    data() {
      return {
        isSidebarOpen: false,
        isSidebarLocked: false,
        currentPage: 'home',
      };
    },
    methods: {
      
      // toggleSidebar() {
      //   this.isSidebarOpen = !this.isSidebarOpen;
      // },
      toggleSidebar() {
      if (!this.isSidebarLocked) {
        this.isSidebarOpen = !this.isSidebarOpen;
      }
    },
      // showPage(page) {
      //   this.currentPage = page;
      //   this.isSidebarOpen = false;
      // },

      toggleLock() {
      this.isSidebarLocked = !this.isSidebarLocked;
    },
    showPage(page) {
    this.$router.push({ query: { currentPage: page } }); // Update URL
    this.currentPage = page;
    // Close the sidebar after selecting a page, unless it's locked
    if (!this.isSidebarLocked) {
      this.isSidebarOpen = false;
    }
  },
    },

    created() {
    // Check for the currentPage query parameter
    this.currentPage = this.$route.query.currentPage || ''; // Default to an empty string or another component
  },
  watch: {
    // Watch for route changes to update currentPage
    '$route'(to) {
      this.currentPage = to.query.currentPage || '';
    },
  },

  mounted() {
    const savedTheme = localStorage.getItem('themeMode') || 'light-mode';
    document.body.classList.add(savedTheme);
  }
  };
  </script>
  
  <style scoped>
#myapp {
  width: 100%; /* Full viewport width */
  height: 100vh; /* Full viewport height */
  display: flex;
  flex-direction: column;
}


  .appName{
    display: none;
  }

  .appNameA{
    display: none;
  }

  .appNameB{
    margin-left: 20%;
  }
  
  .appClass {
    display: flex;
    flex: 1;
  }
  
  .sidebar {
    position: fixed;
    top: 0;
    left: 0; /* Start from the left edge */
    width: 60px; /* Compact width */
    height: 100%; /* Use viewport height for full height */
    background-color: black;
    transition: width 0.3s ease;
    overflow: hidden;
    white-space: nowrap;
  }
  
  .sidebar-open {
    width: 260px; /* Expanded width */
    overflow: hidden; /* Prevent scrolling if the content overflows */
  }

  .lock-btn {
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
}

.lock-btn i {
  transition: color 0.3s ease;
}

.lock-btn i.bi-lock {
  color: #ffcc00; /* Locked color */
}

.lock-btn i.bi-lock-open {
  color: #00ff00; /* Unlocked color */
}
  
  .sidebar-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 20px;
  }
  
  .sidebar-content ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .sidebar-content li {
    margin: 10px 0;
  }
  
  .sidebar-content a {
    color: white;
    text-decoration: none;
    font-size: 1.5rem;
    gap: 10px;
    display: flex;
    align-items: center;
    padding: 10px; /* Add padding for better hover effect */
    transition: background-color 0.3s ease, color 0.3s ease; /* Smooth transition for hover effects */
  }
  
  .sidebar-content a:hover {
    background-color: #555; /* Background color on hover */
    color: #f0f0f0; /* Text color on hover */
  }
  
  .sidebar-content a span {
    margin-left: 10px;
  }
  
  .sidebar-open .sidebar-content a {
    font-size: 1rem;
  }
  
  .main-content {
    flex: 1;
    margin-left: 0;
    /* margin-left: 60px; */
    transition: margin-left 0.3s ease;
  }

  .sub-content{
    margin-top: 60px !important;
    margin-left: 60px !important;
  }

  
  .shift-right {
    margin-left: 260px; /* Adjust content position */
    transition: margin-left 0.3s ease; /* Smooth transition for margin-left */
  }

  .shift-right .sub-content {
    margin-left: 0px !important; /* Shift 60px to the right */
    transition: margin-left 0.3s ease;
  }
  
  .navbar {
    position: fixed;
    width: 100%;
    /* height: 56px; */
    margin-bottom: 1rem;
    padding-left: 15px;
    gap: 10px;
  }

  .sidebar-open + .main-content .loginHeader {
  margin-right: 265px;
}

  .loginHeader {
    transition: margin-right 0.3s ease; /* Smooth transition for margin-right */
  margin-right: 5px; /* Remove margin if it's pushing the header out of view */
}

.mobile-only {
  display: none; /* Hide by default (desktop) */
}



  
  .close-btn {
    margin: 10px;
  }
  
  @media (max-width: 769px) {

    .appName{
    display: block;
  }

    .appNameB{
        display: none;
  }

  .mobile-only {
    display: block; /*Login Header Show only in mobile view */
  }

  .desktop-only{
    display: none;
  }

  .shift-right {
    display: none;
  }

   .bi{
   font-size: medium !important; 
  }


  .sidebar {
    width: 40px; /* Compact width */
  }

  .sidebar-open {
    width: 280px; /* Expanded width */
  }

  .sub-content{
    margin-top: 60px !important;
    margin-left: 40px !important;
  }

  
  }
  </style>
  